import AbsComponent from './common/AbsComponent';
import { Expo } from 'gsap/all';

class Navi extends AbsComponent {

    constructor(_name='', _store={}, _el='') {
        super(_name, _store, _el);
        
        this.naviWrap = $(_el + ' .nav-wrap').hide();
        this.openNavBtn = $(_el + ' .nav-toggle.open').hide();
        this.closeNavBtn = $(_el + ' .nav-toggle.close');

        TweenMax.set( this.naviWrap, {x:-430});
        TweenMax.set( this.openNavBtn, {x:-110});

        const watch = this.watch(this.store.getState, 'secCookiesIsFull');
        this.store.subscribe( watch( (_newVal)=>{
            if (_newVal) {
                this.naviWrap.show();
                this.openNavBtn.show();
                TweenMax.to( this.openNavBtn, 0.4, {x:0, ease:Quint.easeOut, delay: 1});
            }
        }));

        let watchnowpage = this.watch(this.store.getState, 'nowpage', this.isEqual);
        this.store.subscribe( watchnowpage( (newVal, oldVal, path) => {
            $('#nav-controller .btn-nav').removeClass('is-active');
            $('#nav-controller .nav-' + newVal).addClass('is-active');
            this.navClose();
        }));

        this.addEvents();
    }

    addEvents() {
        $('#nav-controller .btn-nav').on('click', (e)=> {
            e.preventDefault();
            this.store.dispatch( this.actions.setNowpage($(e.currentTarget).data('name')) );
            this.navClose();
        });

        this.openNavBtn.on('click', (e)=> {
            this.navOpen();
        });
        
        this.closeNavBtn.on('click', (e)=> {
            this.navClose();
        });
    }

    navClose(){
        TweenMax.to( this.naviWrap, 0.4, {x:-430, ease:Quint.easeIn});
        TweenMax.to( this.openNavBtn, 0.4, {x:0, ease:Quint.easeOut, delay: 0.2});
    }

    navOpen(){
        this.naviWrap.show();
        TweenMax.to( this.naviWrap, 0.5, {x:0, ease:Quint.easeOut });
        TweenMax.to( this.openNavBtn, 0.3, {x:-110, ease:Expo.easeOut });
    }


} // end of class
export default Navi;